export default {
  CUSTOMER_TYPE: '_customer_type',
};
